import { Spinner } from "@abb/abb-common-ux-react";
import React from "react";

interface IProps { }
interface IState { }

export default class SampleLoadingIndicator extends React.Component<IProps, IState> {
    public render() {
        return (
            <div>
                <div className="sample-loader">
                      <Spinner color='blue' sizeClass='medium' />
                </div>
                <div className="loader-backdrop loader-fade-in loader-transition">
                </div>
            </div>
        )
    }


}